export default () => {
  document.querySelectorAll("a.site-logo__link").forEach((link) => {
    link.addEventListener("click", (event) => {
      const targetElement = event.currentTarget;

      if (targetElement.target === "_blank") {
        setTimeout(() => {
          targetElement.blur();
        }, 0);
      }
    });
  });
};
